import React, { useState } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';

import Input from '../../../../../common/data-entry/Input';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup/ButtonGroup';
import { getEventStartDate } from '../../Patients/PatientInfo/EncountersSection/EncountersTab/utils';

import './CancelEncounterModal.scss';

function CancelEncounterModal({ modalBox, onConfirm, encounterName, appointments, currentStudy }) {
  const [input, setInput] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [cancelActiveEvents, setCancelActiveEvents] = useState(true);

  const showCancelActiveEventsCheckbox = appointments.some(appointment => appointment.canceled === false);

  const handleInputChange = e => {
    let text = e.target.value;
    setInput(text);
    setValidationError(false);
  };

  const handleCheckboxChange = e => {
    setCancelActiveEvents(e.target.checked);
  };

  const closeEncounter = e => {
    if (!input) {
      e.preventDefault();
      setValidationError(true);
      return;
    }
    onConfirm(input, showCancelActiveEventsCheckbox && cancelActiveEvents);
  };

  return (
    <>
      <ModalBoxes.Header>Cancel Encounter?</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="mt-4">
          <h5>Encounter</h5>
          <p>{encounterName}</p>
        </div>
        <div className="my-4 pt-2">
          <h5>Appointments</h5>
          {appointments.length ? (
            appointments.map(({ start }, index) => {
              return <p key={index}>{getEventStartDate(start, currentStudy)}</p>;
            })
          ) : (
            <p>None</p>
          )}
        </div>
      </ModalBoxes.Body>
      <div className="cancel-comment-div">
        <Input
          label="Reason"
          onChange={handleInputChange}
          value={input}
          required={true}
          valid={!validationError}
          validationMessage={validationError ? 'Comment is required' : null}
        />
        {showCancelActiveEventsCheckbox && (
          <div className="mt-3">
            <FormControlLabel
              label="Cancel related appointments"
              control={<Checkbox checked={cancelActiveEvents} onChange={handleCheckboxChange} />}
            />
          </div>
        )}
      </div>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            NO
          </Button>
          <Button onClick={closeEncounter}>YES</Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}

CancelEncounterModal.className = 'cancel-encounter-modal';
CancelEncounterModal.size = 'w650';

export default CancelEncounterModal;

CancelEncounterModal.defaultProps = {
  appointments: []
};

CancelEncounterModal.propTypes = {
  modalBox: PropTypes.shape({
    id: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired
  }),
  onConfirm: PropTypes.func.isRequired,
  appointments: PropTypes.array
};
